import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${typeof window !== 'undefined' ? window.location.origin : process.env.REACT_APP_BACKEND_URL || ''}/api`;

const BrandingContext = createContext({
    name: 'Ordini',
    brand_color: '#1a472a',
    logo_url: null,
    slug: 'pezzotti',
    refresh: () => {},
});

export function BrandingProvider({ children }) {
    const [branding, setBranding] = useState({
        name: 'Ordini',
        brand_color: '#1a472a',
        brand_color_secondary: '#FFCC00',
        logo_url: null,
        slug: 'pezzotti',
    });

    const load = useCallback(async () => {
        try {
            // 1) Admin loggato → /company/settings (include logo completo del proprio tenant)
            // 2) Cliente loggato → /me/branding (branding della PROPRIA azienda)
            // 3) Anonimo (login page) → /branding pubblico (default o per slug)
            let res;
            try {
                res = await axios.get(`${API}/company/settings`);
            } catch (_e1) {
                try {
                    res = await axios.get(`${API}/me/branding`);
                } catch (_e2) {
                    res = await axios.get(`${API}/branding`);
                }
            }
            setBranding({
                name: res.data.name || 'Ordini',
                brand_color: res.data.brand_color || '#1a472a',
                brand_color_secondary: res.data.brand_color_secondary || '#FFCC00',
                logo_url: res.data.logo_url || null,
                slug: res.data.slug || 'pezzotti',
            });
        } catch (_e) {
            // Keep defaults on failure
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    // Re-fetch branding when auth state changes (login/logout) so a tenant
    // sees its own name/logo without a full page reload.
    useEffect(() => {
        const handler = () => load();
        window.addEventListener('branding:refresh', handler);
        return () => window.removeEventListener('branding:refresh', handler);
    }, [load]);

    // Apply brand color to CSS custom property so components can reference it.
    // Il titolo della scheda resta sempre il brand di prodotto OmniGlide.
    useEffect(() => {
        if (typeof document !== 'undefined') {
            document.documentElement.style.setProperty('--brand-color', branding.brand_color);
            document.documentElement.style.setProperty('--brand-color-secondary', branding.brand_color_secondary);
            document.title = 'OmniGlide';
        }
    }, [branding.brand_color, branding.brand_color_secondary]);

    return (
        <BrandingContext.Provider value={{ ...branding, refresh: load }}>
            {children}
        </BrandingContext.Provider>
    );
}

export function useBranding() {
    return useContext(BrandingContext);
}
